// Include scss
import "../scss/index.scss";

// Images
import "./images.js";

/* 
    Libs 
*/

// Lazyload
import LazyLoad from "vanilla-lazyload";
var myLazyLoad = new LazyLoad();
myLazyLoad.update();

// Swiper
import { Swiper, Pagination } from 'swiper';
import '../../node_modules/swiper/swiper.scss';

if (window.innerWidth < 920) {
    const swiper = new Swiper('#js-slider-1', {
        modules: [Pagination],
        spaceBetween: 16,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
            el: ".js-slider-1-pagination",
        },
        breakpoints: {

        }
    });

    for (let slider of document.querySelectorAll('.xhm-bl__swiper')) {
        let elPaginationNumbs = slider.querySelector('.xhm-bl__paginationNumbs');
        let sliderSwiper = new Swiper(slider, {
            modules: [Pagination],
            centeredSlides: true,
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
            },
            on: {
                init: function () {
                    elPaginationNumbs.innerText = (this.realIndex + 1) + "/" + this.slides.length
                },
                slideChange: function () {
                    elPaginationNumbs.innerText = (this.realIndex + 1) + "/" + this.slides.length
                },
            },
        });
    }
}
// MagicScroll + GSAP

import ScrollMagic from 'scrollmagic';
import { TweenMax, TimelineMax, gsap, CustomEase } from "gsap"; // What to import from gsap
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
/*
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax); // Pass gsap import to Scrollmagic

var controller = new ScrollMagic.Controller();
var scene = new ScrollMagic.Scene({ triggerElement: "#my-sticky-element-trigger", duration: "50%" })
    .setTween("#my-sticky-element", {
        backgroundColor: "blue",
        scale: 0.7,
        x: '300px',
        rotate: 180
    })
    .addTo(controller);
*/

// Header GSAP
let count = 0;
function headerImageLoad() {
    count++;
    if (count = 4) {

    }
    console.log(count);
}


function animateImages(images) {
    if (window.innerWidth < 920) {
        for (let img2 of images) {
            console.log('classList add visible')
            img2.classList.add('visible');
        }
        gsap.fromTo(images[0], { left: `${-15}rem`, top: `${0}rem`, rotate: 25 }, { left: `${-2.66}rem`, top: `${0.44}rem`, rotate: 0, duration: 1.2, delay: 0.5, ease: "power4.out" });
        gsap.fromTo(images[1], { left: `${3.69}rem`, top: `${-22}rem`, rotate: -28 }, { left: `${3.69}rem`, top: `${2.81}rem`, rotate: 0, duration: 1.2, delay: 0.5, ease: "power4.out" });
        gsap.fromTo(images[2], { right: `${-12}rem`, top: `${10}rem`, rotate: -13 }, { right: `${2.56}rem`, top: `${1.33}rem`, rotate: 0, duration: 1.2, delay: 0.5, ease: "power4.out" });
        gsap.fromTo(images[3], { right: `${-25}rem`, top: `${-5}rem`, rotate: 34 }, { right: `${-2.85}rem`, top: `${0.44}rem`, rotate: 0, duration: 1.2, delay: 0.5, ease: "power4.out" });
    } else {
        for (let img2 of images) {
            console.log('classList add visible')
            img2.classList.add('visible');
        }
        gsap.fromTo(images[0], { left: -1500, top: -1500, rotate: 25 }, { left: -79, top: 42, rotate: 0, duration: 1.2, delay: 0.5, ease: "power4.out" });
        gsap.fromTo(images[1], { left: 1500, top: -500, rotate: -28 }, { left: -46, top: -80, rotate: 0, duration: 1.2, delay: 0.5, ease: "power4.out" });
        gsap.fromTo(images[2], { left: 1500, top: -1500, rotate: -13 }, { left: 52, top: -14, rotate: 0, duration: 1.2, delay: 0.5, ease: "power4.out" });
        gsap.fromTo(images[3], { left: 1500, top: 1500, rotate: 34 }, { left: 0, top: 0, rotate: 0, duration: 1.2, delay: 0.5, ease: "power4.out" });
    }
}

window.addEventListener('DOMContentLoaded', () => {
    let images = [];

    if (window.innerWidth < 920) {
        images = document.querySelectorAll('#header-image img');

    } else {
        images = document.querySelectorAll('#header-image_d img');
        for (let image of images) {
            /*
            image.addEventListener('click', () => {
                for (let img of images) {
                    img.classList.remove('up');
                };
                image.classList.add('up');
            });
            */

            image.addEventListener('mouseenter', () => {
                //gsap.to(image, { scale: 1.05, duration: 0.2 })
                for (let image of images) {
                    image.classList.remove('up'); 
                }
                image.classList.add('up');

            })

        }
    }


    let alreadyLoads = 0;
    for (let img of images) {
        if (img.complete && img.naturalHeight !== 0) {
            alreadyLoads++;
        }
    }

    if (alreadyLoads === images.length) {
        animateImages(images);
    } else {

        let loades = 0;
        for (let img of images) {
            img.addEventListener('load', () => {
                loades++;
                if (loades === images.length) {
                    animateImages(images);
                }
            });
        }
    }






    for (let elem of document.querySelectorAll('.js-scroll-to')) {
        elem.addEventListener('click', (e) => {
            e.preventDefault();
            let element = document.querySelector(elem.getAttribute('data-scroll-to'));
            let y = element.getBoundingClientRect().top + window.scrollY;
            if (window.innerWidth >= 920) {
                y -= 80;
            } else {
                y -= 40;
            }
            window.scroll({
                top: y,
                behavior: 'smooth'
            });
        });
    }


    let btn = document.querySelector('#js-red-btn');
    let trigger = document.querySelector('#js-red-btn-trigger');
    let trigger2 = document.querySelector('#js-red-btn-trigger2');


    window.addEventListener('scroll', (e) => {
        let rect = trigger.getBoundingClientRect();
        let rect2 = trigger2.getBoundingClientRect();

        if (rect.top < window.innerHeight) {
            btn.classList.add('view');
        } else {
            btn.classList.remove('view');
        }

        let offset = 54 + 70;

        if (window.innerWidth < 920) {
            offset = 108;
        }

        if (rect2.top - window.innerHeight + offset < 0) {
            btn.classList.add('hold');
        } else {
            btn.classList.remove('hold');
        }


    });

});